import type { IconName } from '@customerio/pluma-icons';
import { getChannelIcon } from '@/services/messaging-channels';

/**
 * How an inbound message's channel reads in the activity feed. The log's `name` is the channel id
 * services sent (`sms`, `whatsapp`); matching is case-insensitive because older inbound data
 * carries `SMS`. An unknown channel keeps its raw name as the label and gets the SMS icon, so an
 * unrecognized event still renders (Ember `utils/inbound-channels`).
 */
const SMS_ICON: IconName = getChannelIcon('sms');

const INBOUND_CHANNELS: readonly { id: string; label: string; icon: IconName }[] = [
  { id: 'sms', label: 'SMS', icon: SMS_ICON },
  { id: 'whatsapp', label: 'WhatsApp', icon: getChannelIcon('whatsapp') },
];

function findInboundChannel(name: string | null | undefined) {
  const normalized = (name ?? '').toLowerCase();
  return INBOUND_CHANNELS.find((channel) => channel.id === normalized);
}

export function isWhatsAppInbound(name: string | null | undefined): boolean {
  return findInboundChannel(name)?.id === 'whatsapp';
}

export function inboundChannelLabel(name: string | null | undefined): string {
  return findInboundChannel(name)?.label ?? name ?? '';
}

export function inboundChannelIcon(name: string | null | undefined): IconName {
  return findInboundChannel(name)?.icon ?? SMS_ICON;
}
